import { render, staticRenderFns } from "./seckillSetting.vue?vue&type=template&id=c4efbc7c&scoped=true&"
import script from "./seckillSetting.vue?vue&type=script&lang=js&"
export * from "./seckillSetting.vue?vue&type=script&lang=js&"
import style0 from "./seckillSetting.vue?vue&type=style&index=0&id=c4efbc7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4efbc7c",
  null
  
)

export default component.exports